var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhyInvestIcOrnament = function SvgWhyInvestIcOrnament(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 71 160"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B44444",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.006,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.002,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.002,
    cy: 65,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 95,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.006,
    cy: 125,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.004,
    cy: 155,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.014,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.012,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.012,
    cy: 65,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.006,
    cy: 95,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.01,
    cy: 125,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.012,
    cy: 155,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.018,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.014,
    cy: 35,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.018,
    cy: 65,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.014,
    cy: 95,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.016,
    cy: 125,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.016,
    cy: 155,
    r: 5
  }))));
};
export default SvgWhyInvestIcOrnament;